export function updateStageAndItemOrder(oldStages, received) {
    // Create maps for quick lookups
    const { stageMap, itemMap } = createLookupMaps(oldStages);
    
    // Process and update stages
    const updatedStages = processStages(received, stageMap, itemMap);
    
    // Handle stages that weren't in the received data
    const missingStages = findMissingStages(oldStages, received);
    
    return [...updatedStages, ...missingStages];
}

function createLookupMaps(stages) {
    const stageMap = new Map(stages.map(s => [s.id, s]));
    const itemMap = new Map();
    
    stages.forEach(stage => {
        stage.items.forEach(item => {
            itemMap.set(item.id, { ...item });
        });
    });
    
    return { stageMap, itemMap };
}

function processStages(received, stageMap, itemMap) {
    return received
        .map(stageData => updateStage(stageData, stageMap, itemMap))
        .filter(Boolean)
        .sort((a, b) => a.index - b.index);
}

function updateStage(stageData, stageMap, itemMap) {
    const oldStage = stageMap.get(stageData.id);
    if (!oldStage) return null;

    const items = stageData.items.length > 0 ? updateItems(stageData.items, itemMap) : oldStage.items;

    return {
        ...oldStage,
        index: stageData.index,
        content_groups_count: stageData.content_groups_count,
        items,
    };
}

function updateItems(items, itemMap) {
    return items
        .map(itemData => {
            const oldItem = itemMap.get(itemData.id);
            if (!oldItem) return null;
            
            return {
                ...oldItem,
                index: itemData.index,
            };
        })
        .filter(Boolean)
        .sort((a, b) => a.index - b.index);
}

function findMissingStages(oldStages, received) {
    return oldStages.filter(s => !received.some(r => r.id === s.id));
}
